import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import BookTickets from './components/BookTickets'
import Calendar from './components/calendar/Calendar'
import CustomSelect from './components/CustomSelect'
import EventTicketButton from './components/EventTicketButton'
import LiveQueueTime from './components/LiveQueueTime'
import Modal from './components/Modal'
import Newsletter from './components/Newsletter'
import PricingTable from './components/PricingTable'
import QueueTimes from './components/queueTimes/QueueTimes'
import TicketNotification from './components/TicketNotification'
import configureStore from './store/store'

const StoreInstance = configureStore()
const ReduxProvider = Provider as unknown as React.ComponentType<{
  store: unknown
  children?: React.ReactNode
}>

const renderComponent = (node: React.ReactElement, element: Element) => {
  createRoot(element).render(node)
}
const withProvider = (child: React.ReactElement) =>
  React.createElement(ReduxProvider, { store: StoreInstance }, child)

// Mount Calendar components
let elements = document.querySelectorAll<HTMLElement>('.ReactCalendar')
for (const element of elements) {
  renderComponent(withProvider(React.createElement(Calendar)), element)
}

// Mount BookTickets components
elements = document.querySelectorAll<HTMLElement>('.ReactBookTickets')
for (const element of elements) {
  renderComponent(withProvider(React.createElement(BookTickets)), element)
}

// Mount QueueTimes components
elements = document.querySelectorAll<HTMLElement>('.ReactQueueTimesComponent')
for (const element of elements) {
  renderComponent(withProvider(React.createElement(QueueTimes)), element)
}

// Mount LiveQueueTime components
elements = document.querySelectorAll<HTMLElement>(
  '.ReactLiveQueueTimeComponent',
)
for (const element of elements) {
  renderComponent(withProvider(React.createElement(LiveQueueTime)), element)
}

// Mount CustomSelect components
elements = document.querySelectorAll<HTMLElement>('.ReactCustomSelectComponent')
for (const element of elements) {
  const customSelectData = element.dataset as {
    name?: string
    options?: string
  }
  if (!customSelectData.name || !customSelectData.options) {
    continue
  }
  renderComponent(
    withProvider(
      React.createElement(CustomSelect, {
        name: customSelectData.name,
        options: customSelectData.options,
      }),
    ),
    element,
  )
}

// Mount PricingTable components
elements = document.querySelectorAll<HTMLElement>('.ReactPricingTable')
for (const element of elements) {
  renderComponent(
    withProvider(React.createElement(PricingTable, { data: element.dataset })),
    element,
  )
}

// Mount EventTicketButton components
elements = document.querySelectorAll<HTMLElement>('.ReactEventTicketButton')
for (const element of elements) {
  renderComponent(
    withProvider(
      React.createElement(EventTicketButton, { data: element.dataset }),
    ),
    element,
  )
}

// Mount Modal components
elements = document.querySelectorAll<HTMLElement>('.ReactModalComponent')
for (const element of elements) {
  renderComponent(withProvider(React.createElement(Modal)), element)
}

// Mount Newsletter components
elements = document.querySelectorAll<HTMLElement>('.ReactNewsletter')
for (const element of elements) {
  renderComponent(withProvider(React.createElement(Newsletter)), element)
}

// Mount TicketNotification components
elements = document.querySelectorAll<HTMLElement>('.ReactTicketNotification')
for (const element of elements) {
  renderComponent(
    withProvider(React.createElement(TicketNotification)),
    element,
  )
}
